var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"button",staticClass:"small-12 cell wide-btn vertical-align-middle",class:{ 'active': _vm.active },attrs:{"tabindex":_vm.tabIndex},on:{"click":_vm.clicked,"keypress":_vm.clicked}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9e8302","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/rare-patternlab/src/components/buttons/RareStandardButton.vue
// module id = null
// module chunks = 